import Redux from 'redux';
import * as Bixby from '$/core';
import {
  CloDealManagerState,
  CloDealActionTypes,
  ALL_CLO_DEAL_MANAGER_SUCCESS,
  ALL_CLO_DEAL_MANAGER_FAILURE,
  ALL_CLO_DEAL_MANAGER_LOADING,
} from './types';

const initialState: CloDealManagerState = {
  isLoading: false,
  error: undefined,
  cloDealManagers: undefined,
  isAddingCloDealManagerToClient: false,
};

const cloDealManagerReducer: Redux.Reducer<CloDealManagerState> = (state = initialState, action: CloDealActionTypes): CloDealManagerState => {
  switch (action.type) {
    case ALL_CLO_DEAL_MANAGER_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    
    case ALL_CLO_DEAL_MANAGER_SUCCESS:
      const allCloDealManagerPayload = action.payload as Bixby.Models.CloDealManager[];
      return {
        ...state,
        isLoading: false,
        cloDealManagers: allCloDealManagerPayload,
        error: undefined,
      };
    case ALL_CLO_DEAL_MANAGER_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload as Bixby.Models.BixbyError,
      };
    default:
      return state;
  }
};

export default cloDealManagerReducer;
